var $b63a28c481ab9ee3$exports = {};
$b63a28c481ab9ee3$exports = {
  "decrease": function decrease(args) {
    return "Sc\u0103dere ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Cre\u0219tere ".concat(args.fieldLabel);
  },
  "numberField": "C\xE2mp numeric"
};
export { $b63a28c481ab9ee3$exports as default };